import { useSearchParams } from "react-router-dom"
//import "../../styles/return.css"

export default function Return() {
	const [searchParams] = useSearchParams()

	return (
		<div id="exemptions-portal--return" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">
						Thank you for using our online portal for exemptions!
					</h1>
					{
						searchParams.get("event") === "signing_complete" ?
							<>
								<div className="bg-navy p-3 rounded text-light mb-3">
									<h2 className="text-center h1 m-0">
										<i className="fa-regular fa-circle-check" aria-hidden></i> Exemption Request Sent!
									</h2>
								</div>
								<p className="return-text return-text-max-width bold-text">
									Your application has been submitted for review, and you will receive a confirmation e-mail once it has been processed.
								</p>
							</> :
							searchParams.get("event") === "cancel" ||
							searchParams.get("event") === "session_timeout" ||
							searchParams.get("event") === "ttl_expired" &&
							<p className="return-text return-text-max-width bold-text">
								You may return to your DocuSign envelope at any time by logging back in through here.
							</p>
					}
					<p className="return-text return-text-max-width bold-text">
						If you have any questions, please contact our office at <a className="text-navy text-decoration-none" href="mailto:exemptions@srcpa.gov">exemptions@srcpa.gov</a> or <a className="text-navy text-decoration-none" href="tel:+18509831880">(850) 983-1880</a>.
					</p>
				</div>
			</div>
		</div>
	);
}